// extracted by mini-css-extract-plugin
module.exports = {"titleSide":"FacilityDetails_titleSide__1AEo0","titleMain":"FacilityDetails_titleMain__1X2k_"};